import React, { useState, useEffect } from "react";
import constant from "../../../../utils/constants";

const Distribution = ({
  distribution,
  sliders,
  pieData,
  setPieData,
  setUserSelection,
  preset,
  setPreset,
  setDefaultSlider,
  showPreset,
  setShowPreset,
  selectedItems,
}) => {
  const presetClass = showPreset ? "d-block" : "d-none";
  const [distTitle, setDistTitle] = useState(constant.PICK_DISTRO);

  useEffect(() => {
    if (selectedItems?.distribution?.presetName === constant.MY_DISTRO)
      setShowPreset(false);
  }, []);

  useEffect(() => {
    setPieData(sliders.map((a) => a.defaultValue));
    if (showPreset) {
      setDistTitle(constant.PICK_DISTRO);
    } else {
      setDistTitle(constant.DISTRIBUTION);
      setPreset(constant.MY_DISTRO);
    }
  }, [showPreset, setPreset, sliders, setDistTitle]);

  const changePreset = (id) => {
    if (distribution.length) {
      let pd = [];
      //Please dont change the order this will impact
      pd[0] = distribution[id].beneficiary_distro;
      pd[1] = distribution[id].sponsor_distro;
      pd[2] = distribution[id].artist_distro;
      pd[3] = distribution[id].seller_distro;
      setPieData([...pd]);
      setPreset(distribution[id].preset_name);
      setUserSelection({
        distribution: {
          preset_name: distribution[id].preset_name,
          beneficiary_distro: pd[0],
          sponsor_distro: pd[1],
          artist_distro: pd[2],
          seller_distro: pd[3],
          category: "distribution",
          actual_name: distribution[id].preset_name,
        },
      });
      let setSliderDefaultToPreset = sliders.map((sl, i) => {
        sl.defaultValue = pd[i];
        return sl;
      });
      setDefaultSlider(setSliderDefaultToPreset);
    }
  };

  useEffect(() => {
    if (preset.length === 0) changePreset(0);
  }, [distribution.length]);

  const renderContent = () => {
    return (
      <>
        <h3 className="mint__step-title">{distTitle}</h3>
        <div className="mint__dist">
          <span className="mint__dist-desc">
            Pick your Alter-Ego for funds distribution when this NFT is minted
            and each time it is sold:
          </span>
          <div className="mint__dist-presets">
            <div className="preset-wrapper">
              <div className={presetClass}>
                <div className="mint__dist-presets--predefined">
                  {distribution.map((dist, index) => (
                    <div
                      key={index}
                      className={`dist-preset__box ${
                        dist.preset_name === preset
                          ? "dist-preset__box--selected"
                          : ""
                      }`}
                      onClick={() => changePreset(index)}
                    >
                      <span className="dist-preset__text">
                        {dist.preset_name}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  return <React.Fragment>{renderContent()}</React.Fragment>;
};

export default Distribution;
